import Vue from 'vue';

Vue.mixin({
  methods: {
    toast(message, options = {}) {
      const { variant = 'success', noCloseButton = true, noAutoHide = false, title = '' } = options;
      console.log(variant);
      if (typeof message === 'object') {
        //Warum erfolgt diese Überprüfung?
        if (!Array.isArray(message)) {
          message = Object.values(message);
        }
        for (let m in message) {
          this.$bvToast.toast(message[m].description || message, {
            autoHideDelay: 1000,
            variant: variant,
            noCloseButton,
            noAutoHide,
            title,
          });
        }
      } else {
        this.$bvToast.toast(message, {
          autoHideDelay: 1000,
          variant: variant,
          noCloseButton,
          noAutoHide,
          title,
        });
      }
    },
  },
});
